import { createSelector } from 'reselect';
import { getManualCrawler } from 'src/react/manualCrawler/selectors/getManualCrawler';

export const getManualCrawlerTask = createSelector([
    getManualCrawler,
], (manualCrawler) => manualCrawler.crawlerTask);
